<ng-container *ngIf="installationDetailsStore.gatewaySerial$ | async">
  <vi-sidenav-panel sidenav (close)="trackClose()">
    <h1 title data-at-title>
      {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.PANEL.HEADER' | translate }}
    </h1>

    <div filter class="option-wrapper">
      <mat-form-field class="event-type-filter" mat-select-height-large data-at-event-type-filter>
        <mat-label>{{ '+EVENT_LOG.FILTERS.TITLE' | translate }}</mat-label>
        <mat-select [formControl]="eventFiltersForm" multiple fieldTextContentTooltip>
          <mat-select-trigger>
            <div class="selected-option-wrapper">
              <span *ngIf="eventFiltersForm.value?.length" class="selected-option-more-indicator">
                {{
                  '+INSTALLATIONS.INSTALLATION.TRENDING.CHARTS.SELECTED_FEATURES'
                    | translate
                      : {
                          selected: eventFiltersForm.value?.length,
                          available: eventFilterAvailableOptions
                        }
                }}
              </span>
            </div>
          </mat-select-trigger>

          <mat-optgroup
            *ngFor="let eventGroup of eventLogGroups"
            label="{{ customTranslationsService.EVENT_LOG_EVENTS[eventGroup.name] | translate }}"
          >
            <mat-option
              *ngFor="let groupEvent of eventGroup.events"
              (click)="filterChanged()"
              [value]="groupEvent"
              gtm="onSelect"
              gtmAction="Event date"
              gtmCategory="eventLog"
              fieldTextContentTooltip
              >{{ customTranslationsService.EVENT_LOG_EVENTS[groupEvent] | translate }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="datepicker-wrapper" data-at-event-log-datepicker>
        <mat-label>{{ '+EVENT_LOG.DATE_FILTER.TITLE' | translate }}</mat-label>
        <input
          matInput
          readonly
          gtm="onTextField"
          gtmAction="Event date"
          gtmCategory="eventLog"
          [gtmOn]="['focus', 'blur']"
          [max]="maxDate"
          [min]="minDate"
          [matDatepicker]="picker"
          [formControl]="eventDateControl"
          (dateChange)="onDateChange($event)"
          (click)="picker.open()"
          fieldTextContentTooltip
        />
        <button
          *ngIf="eventDateControl.value"
          mat-icon-button
          class="close-button"
          gtm="onClearSearch"
          gtmAction="Event date"
          gtmCategory="eventLog"
          (click)="clearDateFilter()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle
          class="datepicker-icon"
          matSuffix
          [for]="picker"
        ></mat-datepicker-toggle>

        <mat-datepicker
          [touchUi]="(isHandset$ | async) ? 'true' : 'false'"
          #picker
        ></mat-datepicker>
      </mat-form-field>
      <button
        *ngrxLet="eventsStore.isDownloadFileInGeneration$ | async as isDownloadFileBeingGenerated"
        [disabled]="isDownloadFileBeingGenerated"
        class="self-center"
        gtm="onExport"
        gtmAction="Event log download"
        gtmCategory="eventLog"
        mat-raised-button
        color="primary"
        [viConfirm]="viConfirmObject"
        (confirm)="eventsStore.triggerEventLogFileGeneration()"
      >
        <!-- Start download -->
        <ng-container *ngIf="!isDownloadFileBeingGenerated; else downloadInProgress">
          <span> {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.DOWNLOAD.DOWNLOAD' | translate }}</span>
        </ng-container>

        <!-- Download in progress -->
        <ng-template #downloadInProgress>
          <span class="flex items-center gap-[8px]">
            {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.DOWNLOAD.PREPARATION_DOWNLOAD' | translate }}
            <mat-spinner [color]="" [diameter]="20"></mat-spinner>
          </span>
        </ng-template>
      </button>
    </div>

    <div content>
      <app-event-list
        data-at-event-log-event-list
        [installationId]="installationDetailsStore.getInstallationId$ | async"
        [gatewaySerial]="installationDetailsStore.gatewaySerial$ | async"
        [panelContentHeight]="panelContentHeight"
      >
      </app-event-list>
    </div>
  </vi-sidenav-panel>
</ng-container>
